import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import * as CryptoJS from 'crypto-js';

import { ProjectsService } from '../services/projects.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';
import { CookieManagerService } from '../../../shared/services/cookie-manager.service';

import { Sprint, Story } from '../../models';
import { Attachment } from '../../models/attachment';

import { WorkConstants } from "../work.const";

declare var $: any;

@Component({
  selector: 'app-modal-story',
  templateUrl: './modal-story.component.html'
})
export class ModalStoryComponent implements OnInit {

  @Input() projectId: number;
  @Input() sprintId: number;
  @Input() formData: Array<any>;
  @Output() getBacklogData: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('attachFile') attachFile: any;
  @ViewChild('editAttachFile') editAttachFile: any;
  @ViewChild('storyModal') elementRef: ElementRef;
  @ViewChild('taskEditor') taskEditor: ElementRef;

  emitNumber: number;

  storyForm: FormGroup;
  story: Story = new Story();
  currentfile: any;
  attachDescription: string;
  editAttachDescription: string;
  users: any;

  backlogType: string;

  isSubmitted: boolean = false;
  isCreate: boolean = true;
  isDisabledFile: boolean = false;
  isDisabledEditFile: boolean = false;
  isSprints: boolean = false;
  isRemove: boolean = false;
  isView: boolean = false;
  currentDate: string;
  authUser: any = {};

  isCommentEditor: Array<boolean> = [];
  isDeleteConfirm: Array<boolean> = [];
  trasparent: boolean = false;
  attachment: Attachment = new Attachment();

  workConstants: any = WorkConstants;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertManagerService,
    private projectsService: ProjectsService,
    private cookieManagerService: CookieManagerService,
  ) {

  }

  ngOnInit() {
    this.initStoryForm();
    this.currentDate = new Date().toString();

  }

  ngAfterViewInit() {
    // prevent Bootstrap from hijacking TinyMCE modal focus 
    $(document).on('focusin', function (e) {
      if ($(e.target).closest(".mce-window").length) {
        e.stopImmediatePropagation();
      }
    });
  }

  /**
   * change modal size
   * loaded all sprints
   */
  onOpenModal(story?: Story, view?: boolean) {
    if (story) {
      if (view) {
        this.isView = true;
        this.getStoryWithTask(story.id, true);
      } else {
        this.isView = false;
        this.getTask(story.id, true);
        this.isCreate = false;
        this.storyForm.controls['spent_time'].disable();
      }

    } else {
      this.isCreate = true;
      $(this.elementRef.nativeElement).modal({ backdrop: 'static', keyboard: false })
      $(this.elementRef.nativeElement).modal('show');
    }
    this.setIsSprints();
    this.getAuthUser();
  }

  /**
   * set sprint id or not 
   */
  setIsSprints() {
    if (this.sprintId < 0) {
      this.isSprints = false;
    } else {
      this.isSprints = true;
      this.story.sprint_id = this.sprintId;
      this.storyForm.controls['sprint_id'].disable();
    }
  }

  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  /**
   * set story form group
   */
  initStoryForm() {
    this.storyForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: [],
      acc_criteria: [],
      estimated_time: [],
      effort_time_left: [],
      spent_time: [],
      assignee: [],
      status: [],
      sprint_id: [],
      attachDescription: [],
      editAttachDescription: []
    });
  }

  resetForm() {
    //this.storyForm.reset();
    this.attachFile.nativeElement.value = "";
    this.currentfile = null;
    this.isDisabledFile = false;
    this.isSubmitted = false;
    this.isCommentEditor = [];
    this.trasparent = false;
    this.attachDescription = "";
    this.story = new Story();
  }

  createEditObject(): any {
    let editStory = new Story();
    editStory.title = this.story.title;
    editStory.estimate_time = this.story.estimate_time;
    editStory.assignee_id = this.story.assignee_id ? this.story.assignee_id : null;
    editStory.status = this.story.status ? this.story.status : null;
    editStory.sprint_id = this.story.sprint_id;
    editStory.description = this.story.description;
    editStory.effort_time_left = this.story.effort_time_left;
    editStory.acc_criteria = this.story.acc_criteria;

    editStory.attachments = new Array<Attachment>();

    if (this.currentfile || this.attachDescription) {
      let attachment = new Attachment();
      attachment.path = this.currentfile ? this.currentfile.fileName : "";
      attachment.description = this.attachDescription;
      editStory.attachments[0] = attachment;
    }

    return editStory;
  }

  setAttachmentForCreateObject() {
    if (this.currentfile) {
      this.story.attachments = new Array<Attachment>();
      let attachment = new Attachment();
      attachment.path = this.currentfile.fileName;
      attachment.description = this.attachDescription;
      this.story.attachments[0] = attachment;
    }
  }

  openEditCommentForm(id?, attachment?) {
    if (attachment) {
      this.trasparent = true;
      this.isCommentEditor[attachment.id] = true;
    } else {
      this.trasparent = false;
      this.isCommentEditor[id] = false;
      this.getTask(this.story.id, false);
    }
  }

  openDeleteConfirmFrom(attachment) {
    this.trasparent = true;
    this.isDeleteConfirm[attachment.id] = true;
  }

  doConfirmeDelete(event, attachment) {
    if (event) {
      this.deleteTaskAttachment(attachment.id);
    }
    this.trasparent = false;
    this.isDeleteConfirm[attachment.id] = false;
  }

  /**
   * submit story
   */
  doCreateStory() {
    this.isSubmitted = true;
    if (this.storyForm.valid) {
      if (this.isCreate) {
        this.createStory();
      } else {
        this.editStory();
      }
    }
  }

  /**
   * create story
   */
  createStory() {
    this.setAttachmentForCreateObject();
    this.projectsService.createStory(this.projectId, this.story).subscribe(
      success => {
        this.resetForm();
        this.getBacklogData.emit();
        $(this.elementRef.nativeElement).modal('hide');
        this.alertService.success({ title: "SUCCESS", msg: "Successfully Created" });
      },
      error => {
        this.resetForm();
        $(this.elementRef.nativeElement).modal('hide');
      }
    )
  }

  /**
   * create story
   */
  editStory() {
    this.projectsService.editTask(this.story, this.createEditObject()).subscribe(
      success => {
        this.attachFile.nativeElement.value = "";
        this.attachDescription = "";
        this.currentfile = null;
        this.isDisabledFile = false;
        this.getTask(this.story.id, false);
        this.getBacklogData.emit();
        this.alertService.success({ title: "SUCCESS", msg: "Successfully Updated" });
      }
    )
  }

  editTaskAttachment(attachment: any) {
    let body = new Attachment();
    body.path = attachment.path;
    body.description = attachment.description;
    this.projectsService.editTaskAttachment(attachment.id, this.story.id, body).subscribe(
      res => {
        this.isCommentEditor[attachment.id] = false;
        this.trasparent = false;
        this.isRemove = false;
        this.isDisabledEditFile = false;
        this.getTask(this.story.id, false);
        this.alertService.success({ title: "SUCCESS", msg: "Attachment Updated Successfully" });
      }
    );
  }

  deleteTaskAttachment(attachmentId: number) {
    this.projectsService.deleteTaskAttachment(attachmentId).subscribe(
      res => {
        this.getTask(this.story.id, false);
        this.alertService.success({ title: "SUCCESS", msg: "Attachment Deleted Successfully" });
      }
    );
  }

  /**
   * upload file for story
   */
  fileChanged(event) {
    this.projectsService.uploadFile(event.target.files[0]).subscribe(
      file => {
        this.currentfile = file.data;
        this.isDisabledFile = true;
      }
    );
  }

  editFileChanged(event) {
    this.projectsService.uploadFile(event.target.files[0]).subscribe(
      file => {
        this.attachment.path = file.data.fileName;
        this.isDisabledEditFile = true;
      }
    );
  }

  removeFile() {
    this.projectsService.removeFile(this.currentfile.fileName).subscribe(
      file => {
        this.currentfile = null;
        this.isDisabledFile = false;
        this.attachFile.nativeElement.value = "";
      }
    );
  }

  removeEditFile() {
    this.projectsService.removeFile(this.attachment.path).subscribe(
      file => {
        this.attachment.path = null;
        this.isDisabledEditFile = false;
        this.editAttachFile.nativeElement.value = "";
      }
    );
  }

  /**
   * get task details by task id
   */
  getTask(taskId, isShow) {
    this.projectsService.getTask(taskId).subscribe(
      task => {
        this.story = task;
        if (isShow) {
          $(this.elementRef.nativeElement).modal({ backdrop: 'static', keyboard: false })
          $(this.elementRef.nativeElement).modal('show');
        }
      }
    );
  }

  /**
   * get task details by task id
   */
  getStoryWithTask(storyId, isShow) {
    this.projectsService.getStoryWithTask(storyId).subscribe(
      task => {
        this.story = task;
        if (isShow) {
          $(this.elementRef.nativeElement).modal({ backdrop: 'static', keyboard: false })
          $(this.elementRef.nativeElement).modal('show');
        }
      }
    );
  }

  getFileExtintion(fileName): string {
    let file = fileName.split('.');
    let extintion = file[file.length - 1]
    return extintion;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-story.component.ts